import "/src/_includes/layout/base/scripts/index.js"

import '../styles/index.scss'
import $ from 'jquery/dist/jquery'
import 'select2'
import 'select2/dist/css/select2.min.css'
import 'jquery-validation'
import { mails } from './mails.js'

console.log('meow')

window.$ = $

document.addEventListener('DOMContentLoaded', () => {
	//inserting select2 styles
	document.querySelector('head').insertAdjacentHTML('beforeend', '<link href="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css" rel="stylesheet" />')

	$('[data-dd]').select2()
	$('select').on('select2:close', function () {  
		$(this).valid() 
	})

	let balance = document.querySelectorAll('[data-conditional="balance"]')
	let exchange = document.querySelectorAll('[data-conditional="exchange"]')
	let crypto = document.querySelectorAll('[data-conditional="buy-crypto"]')
	let staking = document.querySelectorAll('[data-conditional="staking"]')
	let backup = document.querySelectorAll('[data-conditional="backup-recovery"]')
	let rewards = document.querySelectorAll('[data-conditional="rewards"]')
	let report = document.querySelectorAll('[data-conditional="report"]')
	let pair = document.querySelectorAll('[data-conditional="pair-to-exchange"]')
	let trs = document.querySelectorAll('[data-conditional="transaction"]')
	let address = document.querySelectorAll('[data-conditional="your-coin-address"]')
	let both = document.querySelectorAll('[data-conditional="both"]')
	let cond = document.querySelectorAll('[data-conditional]')


	$('#issue-dropdown').on('change', function() {
		const selected = this.value
		const options = {
			['Balance issue']() {
				showConditionals(balance)
				showConditionals(both)
				showConditionals(address)
			},
			['Transaction issue - deposit, withdrawal']() {
				showConditionals(trs)
				showConditionals(both)
				showConditionals(address)
			},
			['Exchange']() {
				showConditionals(exchange)
			},
			['Buy Crypto']() {
				showConditionals(crypto)
				showConditionals(address)
			},
			['Staking']() {
				showConditionals(staking)
				showConditionals(address)
			},
			['Backup and Recovery']() {
				showConditionals(backup)
			},
			['Cashback, Membership, AWC staking rewards']() {
				showConditionals(rewards)
			},
			['Report a Bug, Security issue, or Scam']() {
				showConditionals(report)
			}
		}
		hideConditionals()
		if (selected in options) return options[selected]()
	})
	$('#exchange-issue-dropdown').on('change', function() {
		const selected = this.value
		const options = {
			['I can\'t exchange an asset']() {
				showConditionals(exchange)
				showConditionals(pair)
				showConditionals(address)
			},
			['My exchange is stuck']() {
				showConditionals(exchange)
			},
			['My exchange failed']() {
				showConditionals(exchange)
			},
			['I don\'t see my funds after exchange']() {
				showConditionals(exchange)
			},
			['Swap rate']() {
				showConditionals(exchange)
			},
			['Pair is not available']() {
				showConditionals(exchange)
				showConditionals(pair)
			},
		}
		hideConditionals()
		if (selected in options) return options[selected]()
	})
	function showConditionals(collection) {
		collection.forEach(item => {
			let name = item.querySelector('.request-form__input').getAttribute('data-name')
			item.querySelector('.request-form__input').setAttribute('name', name)
			item.classList.remove('hidden')
		})
	}
	function hideConditionals() {
		cond.forEach(elem => {
			elem.querySelector('.request-form__input').removeAttribute('name')
			elem.classList.add('hidden')
		})
	}


	$.validator.addMethod('noSelected', function(value, element, arg){   
		return arg !== value
	})
	$.validator.addMethod('noBnb', function(value){   
		return value.indexOf('bnb') !== -1
	})
	$.validator.addMethod('invalidText', function(value){   
		return /[\xCC\xCD]/.test( value ) || /^[a-zA-Z0-9.,?; ()\[\]{}\n-]*$/.test(value)
	})

	$('.request-form').validate({ 
		rules: {
			'Your Atomic ID': {
				required: true,
				invalidText: true
			},
			'Your Swap Order ID': {
				required: true,
				invalidText: true
			},
			'Your coin address': {
				required: true,
				invalidText: true
			},
			'Your Payment ID': {
				required: true,
				invalidText: true
			},
			'Transaction hash': {
				required: true,
				invalidText: true
			},
			'What pair do you want to exchange?': {
				required: true,
				invalidText: true
			},
			'Please provide your AWC BNB address (yellow coin)': {
				required: true,
				noBnb: true
			},
			'Transaction Hash or Coin Address': 'invalidText',
			subjectField: 'invalidText',
			descField: 'invalidText',
			emailField: {
				required: true,
				email: true
			},
			'Choose your issue': {
				required: true,
				noSelected: 'default'
			},
			'Transaction issue - deposit, withdrawal': {
				required: true,
				noSelected: 'default'
			},
			'Balance issue': {
				required: true,
				noSelected: 'default'
			},
			'Exchange': {
				required: true,
				noSelected: 'default'
			},
			'Buy Crypto': {
				required: true,
				noSelected: 'default'
			},
			'Staking': {
				required: true,
				noSelected: 'default'
			},
			'Staking coin': {
				required: true,
				noSelected: 'default'
			},
			'Backup and Recovery': {
				required: true,
				noSelected: 'default'
			},
			'Cashback, Membership, AWC staking rewards': {
				required: true,
				noSelected: 'default'
			},
			'Report a Bug, Security issue, or Scam': {
				required: true,
				noSelected: 'default'
			},
			'Choose coin': {
				required: true,
				noSelected: 'default'
			},
			'Are you Sender or Receiver': {
				required: true,
				noSelected: 'default'
			},
		},
		messages: {
			emailField: 'Please specify a valid email address',
			'Your Atomic ID': 'Please enter your Atomic ID',
			'Your Swap Order ID': 'Please enter your Swap Order ID',
			'Your Payment ID': 'Please enter your Payment ID',
			'Your coin address': 'Please enter your Coin Address',
			'Transaction hash': 'Please enter your Transaction Hash',
			'Please provide your AWC BNB address (yellow coin)': 'Please enter your AWC BNB address correctly',
			'What pair do you want to exchange?': 'Please enter a pair what you want to exchange',
			'Choose your issue': 'Please select your issue',
			'Balance issue': 'Please select your Balance issue',
			'Transaction issue - deposit, withdrawal': 'Please select your Transaction issue',
			'Exchange': 'Please select your Swap issue',
			'Buy Crypto': 'Please select your Buy crypto issue',
			'Staking': 'Please select your Staking issue',
			'Backup and Recovery': 'Please select your Backup and Recovery issue',
			'Cashback, Membership, AWC staking rewards': 'Please select your Cashback, Membership, AWC staking rewards issue',
			'Report a Bug, Security issue, or Scam': 'Please select your Report a Bug, Security issue, or Scam issue',
			'Staking coin': 'Please select your Staking coin',
			'Choose coin': 'Please select your coin',
			'Are you Sender or Receiver': 'Please select the right option',
			'Transaction Hash or Coin Address': 'Invalid text',
			subjectField: 'Invalid text',
			descField: 'Invalid text'
		},
		submitHandler: sendMail
	})

	function supReqPopup(isSuccess, email) {
		let success = document.querySelector('.modal-window--success')
		let fail = document.querySelector('.modal-window--fail')
		let popup = document.querySelector('.modal-overlay')
		success.classList.remove('active')
		fail.classList.remove('active')
		if (isSuccess) {
			document.querySelector('.popup-email').innerText = email
			success.classList.add('active')
		} else {
			fail.classList.add('active')
		}
		popup.classList.add('open')

		document.querySelector('.modal-window__close').addEventListener('click', function() {
			this.closest('.modal-overlay').classList.remove('open')
		})
		popup.addEventListener('click', e=>{
			if(e.target.classList.contains('modal-overlay')){
				popup.classList.remove('open')
			}
		})
	}

	document.querySelector('.request-form__file-input').addEventListener('change', function() {
		let label = this.parentNode

		if (this.files.length) {
			let fileName = this.files[0].name

			if ( !label.classList.contains('has-file') ) label.classList.add('has-file')
			document.querySelector('[data-file]').innerText = fileName
		} else {
			label.classList.remove('has-file')
		}
	})

	function sendMail() {
		let userEmail = document.querySelector('#email-field').value

		let formData = new FormData(document.querySelector('.request-form'))

		$.ajax({
			url: '/form/support',
			data: formData,
			method: 'post',
			contentType: false,
			processData: false,
			timeout: 15000,
			error: function(err) {
				console.log(err)
				supReqPopup(false)
			},
			success: function(data) {
				console.log(data)
				if( !data.success ) {
					console.log('Invalid data')
					console.log(data.error)
					supReqPopup(data.success)
				} else {
					console.log('Success')
					supReqPopup(data.success, userEmail)
				}
			}
		})
	}

	let mailList = mails.split('\n')
    let mailField = document.querySelector('#email-field')
    mailField.addEventListener( 'input', debounce(checkMails, 300) )

    function debounce(f, ms) {
        let isCooldown = false;
      
        return function() {
            if (isCooldown) return;
        
            f.apply(this, arguments);
            isCooldown = true;
        
            setTimeout(() => isCooldown = false, ms);
        };
    }
    function checkMails() {
        let val = this.value.split('@')[1]
        let warning = '<span class="support-warning"><img class="support-warning__img" src="/images/icons/warning.svg"> Pay attention, you provided an unknown mailing address. Be sure it is correct.</span>'
        let warningEl = document.querySelector('.support-warning')

        if (warningEl) warningEl.remove()
        if ( val && this.value.includes('@', '.') && this.value.includes('.') && !mailList.includes(val) ) {
            this.insertAdjacentHTML('beforebegin', warning)
        }
    }
})  
